module.exports = __webpack_public_path__ + "img/cards@2x.1201e20.png";